import PageHeader from "components/restaurants/PageHeader"
import Tabbar from "components/utils/navigation/Tabbar"
import TabbarLink from "components/utils/navigation/TabbarLink"
import { ReactNode } from "react"

interface MarketingLayoutProps {
  children: ReactNode
}
const MarketingLayout = ({ children }: MarketingLayoutProps) => {
  return (
    <>
      <PageHeader name="Marketing" helpLink={"https://intercom.help/getpacked/de/collections/2886176-marketing-beta"} />
      <Tabbar>
        <TabbarLink href="/admin/marketing/newsletter">Newsletter</TabbarLink>
        <TabbarLink href="/admin/marketing/discountCodes">Rabattcodes</TabbarLink>
        <TabbarLink href="/admin/marketing/channels">Kanäle</TabbarLink>
        <TabbarLink href="/admin/marketing/subscribers">Abonnenten</TabbarLink>
      </Tabbar>
      {children}
    </>
  )
}

export default MarketingLayout
